import React, {useEffect, useMemo, useState} from "react";
import Sidebar from "../../../../components/SideBar";
import Navbar from "../../../../components/NavBar";
import PatientTable from "./PatientTable";
import "./Patients.css";
import {associatePatient, getAllPatients, getPatients, getUsersFiscalCode,} from "../../../../../service-layer/ChatService";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import SendButton from "../../patients/component/SendButton";
import sendButton from "../../patients/component/SendButton";
import {getStaffId} from "../../../../../axios/CurrentMedicalStaffManager";
import MedicalRecordIcon from "../../patients/component/MedicalRecordIcon";
import {AgGridReact} from "ag-grid-react";

import { useStateContext } from "../../../../../contextProvider";

import {CDBCard, CDBCardBody, CDBContainer, CDBInput, CDBModal,} from "cdbreact";
import {useTranslation} from "react-i18next";
import {CButton, CCol, CHeader} from "@coreui/react";
import LogoutModal from "../../../../components/logout-moal/LogoutModal";

const Patients = () => {
    const {t} = useTranslation();
    const [patients, setPatients] = useState([-1]);
    const [allPatients, setAllPatients] = useState([]);
    const [searchModal, setSearchModal] = useState(false);
    const [searchFiscalCode, setSearchFiscalCode] = useState("");
    const [allUsersFiscalCodes, setAllUsersFiscalCodes] = useState([]);
    const [alreadyAssociatedCode, setAlreadyAssociatedCode] = useState(false);
    const [fiscalCodeData, setFiscalCodeData] = useState({});
    const [selectedPatients, setSelectedPatients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const { setSelectedPatient, setSelectedPatientData, setDoctorPage } = useStateContext()


    const columnsAssociation = [
        {
            field: "surname",
            headerName: t("surname"),
            checkboxSelection: true,
        },

        {
            field: "name",
            headerName: t("name"),
        },

        {
            field: "fiscalCode",
            headerName: t("fiscalCode"),
        },
    ];

    const defaultColDef = useMemo(() => {
        return {
            flex: 1,
            minWidth: 100,
        };
    }, []);

    const col = [
        {field: "surname", headerName: t("surname")},
        {field: "name", headerName: t("name")},
        {field: "fiscalCode", headerName: t("fiscalCode")},
        {
            field: "sendMessage",
            headerName: t("sendMessage"),
            sortable: false,
            filter: false,
            cellRenderer: sendButton,
        },
        {
            field: "more",
            headerName: t("seeMore"),
            sortable: false,
            filter: false,
            cellRenderer: sendButton,
        },
    ];
    const [columns, setColumns] = useState(col);
    const navigate = useNavigate();
    const location = useLocation();

    const handlePatientSelect = (patient) => {
        setPatients(patient);
    };

    const handleSendMessage = (ids) => {
        setDoctorPage('chat')
        navigate("/patients/send_message", {state: ids});
    };

    const handleSeeDetails = (ids) => {
        setDoctorPage('details')
        navigate("/patients/user_details", {state: ids});
    };

    const getPatientById = (id) => {
        // console.log("PATSSSS", patients)
        // if (pats[0].id === "-1") {
        //   console.log("Patient not found");
        //   return {
        //     id: "",
        //     name: "",
        //     surname: "",
        //     fiscalCode: "",
        //     height: "",
        //     weight: "",
        //   };
        // }
        let pats = patients.filter((item) => item.id === id);
        setSelectedPatientData(pats)
        // console.log("FOUNDDD", pats)
        return pats;
    };

    function getPatientsList() {
        getPatients(getStaffId())
            .then((response) => {
                let sortedData = [];
                console.log("SORTED");
                console.log(response);

                if (response.length > 0 && response[0].id !== -1) {
                    sortedData = [...response].sort((a, b) => {
                        if (a.surname < b.surname) return -1;
                        if (a.surname > b.surname) return 1;
                        return 0;
                    });
                }
                setPatients([...sortedData]);
                setLoading(false);
            })
            .catch((e) => {
                console.error("ERROR LOADING PATIENT LIST", e)
                setShowLogoutModal(true);
            });
    }

    useEffect(() => {
        getPatientsList();
    }, []);

    useEffect(() => {
        getAllPatients().then((response) => {
            setAllPatients(response)
        })
        .catch((err) => {
            setShowLogoutModal(true);
            console.log(err)
        });
    },[]);

    useEffect(() => {
        console.log("PATIENTS NOWW", patients);
        const col = [
            {field: "surname", headerName: t("surname")},
            {field: "name", headerName: t("name")},
            {field: "fiscalCode", headerName: t("fiscalCode")},
            {
                field: "sendMessage",
                headerName: t("sendMessage"),
                sortable: false,
                filter: false,
                cellRenderer: (params) => (
                    <SendButton
                        medicalStaffId={getStaffId()}
                        patientId={params.data.id}
                        patientData={getPatientById(params.data.id)}
                        navigateToSendMessage={handleSendMessage}
                    />
                ),
            },
            {
                field: "more",
                headerName: t("seeMore"),
                sortable: false,
                filter: false,
                cellRenderer: (params) => (
                    <MedicalRecordIcon
                        medicalStaffId={getStaffId()}
                        patientId={params.data.id}
                        patientData={getPatientById(params.data.id)}
                        handleSeeDetails={handleSeeDetails}
                    />
                ),
            },
        ];
        setColumns(col);
    }, [patients, t]);

    useEffect(() => {
        if (window.localStorage.getItem("auth_token") === null) navigate("/login");
    }, [navigate]);

    useEffect(() => {
        getUsersFiscalCode()
            .then((response) => {
                console.log("USERS INFO", response);
                setAllUsersFiscalCodes(response);
            })
            .catch((err) => {
                //setShowLogoutModal(true);
                console.log(err)
            });
    }, []);

    function setFiscalData(ev) {
        const code = ev.currentTarget.value;

        const already_associated_codes = allPatients.map((p) =>
            p.fiscalCode.toUpperCase(),
        );

        let available_codes = allUsersFiscalCodes.filter(
            (c) => !already_associated_codes.includes(c.fiscalCode),
        );

        //console.log("DATAAAA", allUsersFiscalCodes)
        const searchData = available_codes
            .filter((user) => user.fiscalCode === code.toUpperCase())
            .map((user) => {
                return {
                    name: user.name,
                    surname: user.surname,
                    fiscalCode: user.fiscalCode,
                };
            });

        console.log("FISCAL DATA", searchData);
        setSearchFiscalCode(code.toUpperCase());
        setAlreadyAssociatedCode(already_associated_codes.includes(code.toUpperCase()));
        setFiscalCodeData(searchData);
    }

    function handleCloseModal() {
        setFiscalCodeData({});
        setSearchModal(false);
        setLoading(false);
        setSearchFiscalCode("");
        setSelectedPatients([]);

        if(localStorage.getItem('doctor_page'))
            localStorage.removeItem("doctor_page");
        localStorage.removeItem("patient_id");
        localStorage.removeItem("staff_id");

        if(localStorage.getItem('patient_data'))
            localStorage.removeItem("patient_data");

        if(localStorage.getItem('patient_name'))
            localStorage.removeItem("patient_name");

        if(localStorage.getItem('patient_surname'))
            localStorage.removeItem("patient_surname");

        setSelectedPatient(undefined)
        setSelectedPatientData(undefined)
        setDoctorPage(undefined)

    }

    const onSelectionChanged = (event) => {
        let rowCount = event.api.getSelectedNodes();
        console.log("selected rowss", rowCount);
        let selected = rowCount.map((row) => row.data);
        let selected_codes = selected.map((p) => p.fiscalCode);
        console.log("SELECTED", selected_codes);
        console.log("FOUND:", allUsersFiscalCodes);

        console.log(
            "FOUND:",
            allUsersFiscalCodes.find((p) => p.fiscalCode === selected_codes[0]),
        );

        const selected_patients = selected_codes.map((code) => {
            return allUsersFiscalCodes.find((p) => p.fiscalCode === code);
        });

        const patientAssociation = selected_patients.map((pat) => {
            return {
                userId: pat.userId,
                medicalStaffId: getStaffId(),
            };
        });

        setSelectedPatients(patientAssociation);
    };

    function handlePatientAssociation() {
        const body = selectedPatients[0];

        if (body) {

            console.log("ASSOCIATION", selectedPatients[0]);
            setLoading(true);
            associatePatient(body)
                .then((resp) => {
                    alert(t("patient_correctly_associated"));
                    getPatientsList();
                    handleCloseModal();
                })
                .catch((err) => alert(t("association_error"), err));
        } else {
            alert(t("select_a_patient_to_associate"));
        }

    }

    // Check if the current route is "send_message"
    const isSendMessageRoute =
        location.pathname === "/patients/send_message" ||
        location.pathname === "/patients/user_details" || location.pathname === "/patients/blood_tests" ||  location.pathname === "/patients/user_documents";
    const token = window.localStorage.getItem("auth_token");

    const handleConfirm = () => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("name");
        localStorage.removeItem("surname");
        localStorage.removeItem("authority");
        setShowLogoutModal(false);
        navigate("/");
    };

    const handleRowClick = (event) => {
        const {id} = event.data;
        const patientData = getPatientById(id)
        const staffId = getStaffId()
        setSelectedPatient(id)

        localStorage.setItem('patient_id', String(id))
        localStorage.setItem('staff_id', String(staffId))
        localStorage.setItem('patient_data', JSON.stringify(patientData[0]))
        localStorage.setItem('patient_name', patientData[0].name)
        localStorage.setItem('patient_surname', patientData[0].surname)

        handleSeeDetails({
            medicalStaffId: staffId,
            patientId: id,
            patientData: patientData,
        });
    };

    const onRowClicked = (event) => {
        const selectedNode = event.node;
        if (selectedNode.isSelected()) {
            selectedNode.setSelected(false); // Deselect if already selected
        } else {
            selectedNode.setSelected(true);  // Select if not selected
        }
    };


    return (
        <>
            {token && (
                <div className="d-flex">
                    <div>
                        <Sidebar/>
                    </div>

                    <div
                        style={{
                            flex: "1 1 auto",
                            display: "flex",
                            flexFlow: "column",
                            height: "100vh",
                            overflowY: "hidden",
                        }}
                    >
                        <Navbar/>
                        {isSendMessageRoute ? (
                            <Outlet/> // This will render the SendMessage component
                        ) : (
                            <>
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        paddingRight: "20px",
                                        marginTop: "20px",
                                    }}
                                >
                                    <div style={{
                                        paddingLeft: '20px'
                                    }}>
                                    { !loading && `${t('numberPatients')}: ` }
                                    { !loading && <strong style={{fontSize: '1.1rem'}}>{ patients ? patients.length: ''}</strong>}
                                    </div>
                                    {!loading && <CButton
                                        className="download-button"
                                        onClick={() => setSearchModal(true)}
                                    >
                                        {t("associate_patient")}
                                    </CButton>}
                                </div>
                                {patients.length > 0 && (
                                    <PatientTable
                                        patients={patients}
                                        onPatientSelect={handlePatientSelect}
                                        columns={columns}
                                        loading={loading}
                                        onRowClicked={handleRowClick}  // Pass the row click handler here
                                    />
                                )}
                                {patients.length === 0 && (
                                    <div
                                        style={{
                                            height: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <h3>{t("no_patients_found")}</h3>
                                    </div>
                                )}
                            </>
                        )}
                        <CDBModal isOpen={searchModal} toggle={handleCloseModal} size="lg">
                            <div style={{padding: "20px"}}>
                                <CDBContainer style={{marginBottom: "10px"}}>
                                    {t("search_patient")}
                                </CDBContainer>
                                <CDBContainer
                                    style={{
                                        marginBottom: "10px",
                                        display: "flex",
                                        width: "100%",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <div style={{width: "75%"}}>
                                        <CDBInput
                                            style={{textTransform: "uppercase"}}
                                            type="text"
                                            placeholder={t("fiscalCode")}
                                            value={searchFiscalCode}
                                            color="primary"
                                            onChange={setFiscalData}
                                        />
                                    </div>
                                    <CButton
                                        className="download-button"
                                        onClick={handlePatientAssociation}
                                    >
                                        {t("associate_patient")}
                                    </CButton>
                                </CDBContainer>
                                {searchFiscalCode !== "" && fiscalCodeData.length > 0 && (
                                    <CDBContainer>
                                        <div
                                            style={{
                                                maxHeight: "400px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                            }}
                                        >
                                            <CDBCard>
                                                <CDBCardBody>
                                                    <div className={"ag-theme-alpine"}>
                                                        <AgGridReact
                                                            rowData={fiscalCodeData}
                                                            columnDefs={columnsAssociation}
                                                            defaultColDef={defaultColDef}
                                                            rowSelection={"single"}
                                                            suppressRowClickSelection={true}
                                                            domLayout="autoHeight"
                                                            onSelectionChanged={onSelectionChanged}
                                                            onRowClicked={onRowClicked}
                                                            // isRowSelectable={isRowSelectable}
                                                            // onGridReady={onGridReady}
                                                            // onFirstDataRendered={onFirstDataRendered}
                                                        />
                                                    </div>
                                                </CDBCardBody>
                                            </CDBCard>
                                        </div>
                                    </CDBContainer>
                                )}

                                {(alreadyAssociatedCode && fiscalCodeData.length === 0) && (
                                    <CDBContainer>
                                        <div
                                            style={{
                                                maxHeight: "400px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                            }}
                                        >
                                            <CDBCard className="center-vertically">
                                                <p>{t("patient_already_associated")}</p>
                                            </CDBCard>
                                        </div>
                                    </CDBContainer>
                                )}


                                {(!alreadyAssociatedCode && fiscalCodeData.length === 0) && (
                                    <CDBContainer>
                                        <div
                                            style={{
                                                maxHeight: "400px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                            }}
                                        >
                                            <CDBCard className="center-vertically">
                                                <p>{t("no_patients_found")}</p>
                                            </CDBCard>
                                        </div>
                                    </CDBContainer>
                                )}
                            </div>
                        </CDBModal>
                    </div>
                </div>
            )}
            {!token && <div className="login-container"></div>}
            <LogoutModal
                show={showLogoutModal}
                handleConfirm={handleConfirm}
                handleClose={handleConfirm}
                title={t("login")}
                message={t("session_expired_please_login_again")}
                tag={"Login"}
            />
        </>
    );
};

export default Patients;
